import {
    getPlanLeadsPerSearch,
    SUBSCRIPTION_TIERS,
} from "../../utils/subscription";

export const SUBSCRIPTION_PLAN_OPTIONS = [
    {
        id: SUBSCRIPTION_TIERS.STARTER,
        name: "Starter",
        bestFor:
            "Validating an ICP, getting the first 10 meetings, learning what works.",
        monthlyCredits: [
            { label: "Monthly lead credits", value: "500 leads/mo" },
            { label: "Monthly email send credits", value: "2,500 emails/mo" },
        ],
        operationalLimits: [
            {
                label: "Per-search lead ceiling",
                value: `${getPlanLeadsPerSearch(
                    SUBSCRIPTION_TIERS.STARTER,
                )} leads per search`,
            },
            { label: "Concurrent active sequences", value: "5 campaigns" },
            { label: "API rate limit", value: "5 requests/sec, burst 10" },
            { label: "AI scoring priority", value: "Low" },
        ],
        benefits: [
            "Start lead searches for your target customers",
            "Create basic email outreach campaigns",
            "Manage up to 5 active campaigns",
        ],
    },
    {
        id: SUBSCRIPTION_TIERS.PRO,
        name: "Pro",
        bestFor: "B2B sales teams with an ICP, quota, and regular outreach needs.",
        monthlyCredits: [
            { label: "Monthly lead credits", value: "750 leads/mo" },
            { label: "Monthly email send credits", value: "5,000 emails/mo" },
        ],
        operationalLimits: [
            {
                label: "Per-search lead ceiling",
                value: `${getPlanLeadsPerSearch(
                    SUBSCRIPTION_TIERS.PRO,
                )} leads per search`,
            },
            { label: "Concurrent active sequences", value: "15 campaigns" },
            { label: "API rate limit", value: "25 requests/sec, burst 50" },
            { label: "AI scoring priority", value: "Medium" },
        ],
        benefits: [
            "More email capacity than Starter",
            "More concurrent campaigns",
            "Higher API rate limit",
        ],
    },
    {
        id: SUBSCRIPTION_TIERS.ENTERPRISE,
        name: "Enterprise",
        bestFor:
            "Multi-product companies, multi-region teams, and org-wide revenue motion.",
        monthlyCredits: [
            { label: "Monthly lead credits", value: "1,500 leads/mo" },
            { label: "Monthly email send credits", value: "7,500 emails/mo" },
        ],
        operationalLimits: [
            {
                label: "Per-search lead ceiling",
                value: `${getPlanLeadsPerSearch(
                    SUBSCRIPTION_TIERS.ENTERPRISE,
                )} leads per search`,
            },
            { label: "Concurrent active sequences", value: "50 campaigns" },
            { label: "API rate limit", value: "100 requests/sec, burst 200" },
            { label: "AI scoring priority", value: "High" },
        ],
        benefits: [
            "Everything in Pro",
            "Top-of-queue AI scoring",
            "Custom SMTP routing",
            "Named CSM + quarterly business review",
        ],
    },
];

const PLAN_SELECTION_ORDER = {
    [SUBSCRIPTION_TIERS.STARTER]: [
        SUBSCRIPTION_TIERS.STARTER,
        SUBSCRIPTION_TIERS.PRO,
        SUBSCRIPTION_TIERS.ENTERPRISE,
    ],
    [SUBSCRIPTION_TIERS.PRO]: [
        SUBSCRIPTION_TIERS.PRO,
        SUBSCRIPTION_TIERS.ENTERPRISE,
    ],
    [SUBSCRIPTION_TIERS.ENTERPRISE]: [
        SUBSCRIPTION_TIERS.ENTERPRISE,
        SUBSCRIPTION_TIERS.STARTER,
        SUBSCRIPTION_TIERS.PRO,
    ],
};

const PLAN_RANKS = {
    [SUBSCRIPTION_TIERS.STARTER]: 1,
    [SUBSCRIPTION_TIERS.PRO]: 2,
    [SUBSCRIPTION_TIERS.ENTERPRISE]: 3,
};

export const isUpgradePlan = (currentPlanName, planId) =>
    currentPlanName !== SUBSCRIPTION_TIERS.ENTERPRISE &&
    PLAN_RANKS[planId] > PLAN_RANKS[currentPlanName];

export const getSubscriptionPlanOptions = (currentPlanName) => {
    const planById = Object.fromEntries(
        SUBSCRIPTION_PLAN_OPTIONS.map((plan) => [plan.id, plan]),
    );
    const planOrder =
        PLAN_SELECTION_ORDER[currentPlanName] ||
        PLAN_SELECTION_ORDER[SUBSCRIPTION_TIERS.STARTER];

    return planOrder.map((planId) => planById[planId]).filter(Boolean);
};
